import React from 'react';
import styled from 'styled-components';

export default () => {
  return (
    <Container>
      <Message>会社情報を取得するとここに表示されます</Message>
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 0;
`;

const Message = styled.p`
  font-size: 12px;
  line-height: 1.5em;
  letter-spacing: 0.04em;
  color: var(--text-color-3);
  margin: 0;
`;
